import { date } from 'quasar'
import Model, { IsoDateTime } from 'src/models/model'
import { useMaximumPreparationTime } from 'src/modules/checkout/composeables/order/PreparationTime'
import { computed } from 'vue'

const { addToDate } = date

const DEFAULT_OPTIONS = Object.freeze({
  showing: null
})

export function useMinimumDeliveryTime (orderItems = [], options = DEFAULT_OPTIONS) {
  const currentSite = Model.configuration?.currentSite
  const { maximumPreparationTime } = useMaximumPreparationTime()

  function computeMinimumDeliveryTime (orderItems, { showing } = DEFAULT_OPTIONS) {
    const timeNow = new Date()

    const minimumDeliveryTime = new IsoDateTime(addToDate(timeNow, { minutes: maximumPreparationTime(orderItems) }))
    const showingTime = showing?.time
    const theaterSeatTabShowingCutoverMinutes = currentSite?.theaterSeatTabShowingCutoverMinutes || 0

    if (_.isNil(showingTime)) {
      return minimumDeliveryTime
    } else {
      const seatingStart = new IsoDateTime(addToDate(showingTime, { minutes: -(theaterSeatTabShowingCutoverMinutes) }))

      return _.max([minimumDeliveryTime, seatingStart])
    }
  }

  const minimumDeliveryTime = computed(() => computeMinimumDeliveryTime(computed(() => orderItems), options))
  return {
    computeMinimumDeliveryTime,
    minimumDeliveryTime
  }
}
